const LiveLocation = () =>
  import(
    /* webpackChunkName: "location-location-live" */ '@/pages/location/location/live-location.vue'
  )


export default {
  path: 'live-location',
  meta: {
    label: 'live',
    auth: 'live'
  },
  component: {
    name: 'Live',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'GeoLocationLiveLocation',
      path: '',
      meta: {
        label: 'report',
        auth: true
      },
      component: LiveLocation
    }
  ]
}
